import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getUser } from '../fetch';

export function useAuth(loginPath = '/login') {
  const navigate = useNavigate();
  const user = getUser();
  const { state: locationState, pathname } = useLocation<string>();

  const isNotExpired = (user?.loginTime || 0) / 1000 + (user?.expiresInSeconds || 0) > dayjs().unix();
  const isAuthenticated = isNotExpired;
  if (!isAuthenticated) {
    localStorage.removeItem('user');
  }

  useEffect(() => {
    if (!isAuthenticated && pathname !== loginPath) {
      navigate(loginPath, { replace: true, state: { pathname } });
    }
  }, [isAuthenticated, loginPath, navigate, pathname]);

  return {
    isAuthenticated,
    user,
    locationState,
  };
}
